/**
 * Заголовок таблиці модуля (прототип v4): «Модуль — Таблиця»; головна таблиця, названа так само, як модуль, — лише назва модуля
 * («Завдання», а не «Завдання — Завдання»). На сторінках окремих подань (зал засідань, аналітика) — рядок над заголовком. Чиста функція.
 */
export function tableTitle(moduleName: string, tableName: string): string {
  return tableName && tableName !== moduleName ? `${moduleName} — ${tableName}` : moduleName;
}
